// extracted by mini-css-extract-plugin
module.exports = {"marketing__article":"article_marketing__article__n6kP3","marketing__article_authorbio":"article_marketing__article_authorbio__aPW3Y"};